export const ACTION_FIELDS = new Set([
  "issue", "description", "recommended_action", "priority", "workorder_type",
  "due_date", "equipment", "assignTo", "reportBy", "status", "complete_date",
]);

export const proposalChanges = (values, selected) => Object.fromEntries(
  Object.entries(values).filter(([field]) => ACTION_FIELDS.has(field) && selected.includes(field)).map(([field, raw]) => {
    if (["due_date", "complete_date", "equipment", "assignTo"].includes(field) && raw === "") return [field, null];
    if (["equipment", "assignTo"].includes(field) && /^\d+$/.test(String(raw))) return [field, Number(raw)];
    return [field, raw];
  })
);

export const sameChanges = (left, right) => {
  const keys = Object.keys(left).sort();
  return keys.length === Object.keys(right).length && keys.every((key) => left[key] === right[key]);
};

export const taskMatchesScope = (task, companyId, facilityId) => Boolean(
  task?.scope && String(task.scope.company_id) === String(companyId) && String(task.scope.facility_id) === String(facilityId)
);
